import { Component, OnInit } from '@angular/core';
import { MenuClaims } from '../../shared/constants/menu-claims';
import { MenuEntry } from '../../shared/interfaces/menu-entry.interface';
import { AccountService, ContentService, } from '../../shared/services/';
import { CONTENT_NAMES } from 'app/shared/constants/content-names';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  userMenuEntries: MenuEntry[];
  permissions = MenuClaims.PERMISSIONS;
  iconPath = 'assets/images/icons/128x128/white/';
  menuEntries: MenuEntry[] = [
    {
      title: 'PORT CALLS',
      iconPath: this.iconPath + 'portcall.png',
      menuName: CONTENT_NAMES.VIEW_PORT_CALLS
    },
    {
      title: 'USERS',
      iconPath: this.iconPath + 'user.png',
      menuName: CONTENT_NAMES.VIEW_USERS
    },
    {
      title: 'SHIPS',
      iconPath: this.iconPath + 'ship.png',
      menuName: CONTENT_NAMES.VIEW_SHIPS
    },
    {
      title: 'LOCATIONS',
      iconPath: this.iconPath + 'location.png',
      menuName: CONTENT_NAMES.LOCATIONS
    },
    {
      title: 'ORGANIZATIONS',
      iconPath: this.iconPath + 'pax.png',
      menuName: CONTENT_NAMES.VIEW_ORGANIZATIONS
    }
  ];
  constructor(
    private contentService: ContentService,
     private accountService: AccountService,
    ) {}

  ngOnInit() {
    this.accountService.userClaimsData$.subscribe(userClaims => {
      if (userClaims) {
        const userClaimsTypeMenu = userClaims.filter(
          claim => claim.type === MenuClaims.TYPE
        );
        const keys = Object.keys(this.permissions);
        keys.forEach(key => {
          this.permissions[key] = userClaimsTypeMenu.some(
            claim => claim.value === key
          );
        });
        this.generateMenu();
      }
    });
  }

  private generateMenu() {
    this.setMenuEntries();
  }


  private setMenuEntries() {
    // Populates the menu entry list with the entries the user has access to

    this.userMenuEntries = [];
    for (const menuEntry of this.menuEntries) {
      const menuName = menuEntry.menuName;
      if (this.permissions[menuName]) {
        this.userMenuEntries.push(
          this.menuEntries.find(
            newMenuEntry => newMenuEntry.menuName === menuName
          )
        );
      }
    }
  }

  setContent(contentName: string) {
    this.contentService.setContent(contentName);
  }

  hasAnyPermission(): boolean {
    return Object.values(this.permissions).some(permission => permission === true);
  }
}



// WEBPACK FOOTER //
// ./src/app/main-content/footer/footer.component.ts